import request from '@/utils/request'

export function getSmsCode(params) { // 获取验证码
  return request({
    url: 'api/z/sms/sendSms',
    method: 'post',
    params
  })
}
export function register(params) { // 注册
  return request({
    url: 'sso/register',
    method: 'post',
    params
  })
}
export function login(params) { // 账号登录
  return request({
    url: 'sso/login',
    method: 'post',
    params
  })
}

export function loginPhone(params) { // 会员手机验证码登录
  return request({
    url: 'sso/loginPhone',
    method: 'post',
    params
  })
}
export function wechatLogin(params) { // 微信扫码登录
  return request({
    url: 'api/z/wechat/login',
    method: 'get',
    params
  })
}

export function wechatNoticeLogin(params) { // 微信消息通知推送绑定
  return request({
    url: '/api/z/weixin/notice/login',
    method: 'get',
    params
  })
}

export function wechatBind(params) { // 微信绑定账号
  return request({
    url: '/sso/bind',
    method: 'post',
    params
  })
}
export function getUserInfo(data) { // 根据token获取用户信息
  return request({
    url: 'sso/info',
    method: 'get',
    data
  })
}

export function getUserAccount(params) { // 会员账户信息
  return request({
    url: 'account',
    method: 'get',
    params
  })
}

export function findPassword(params) { // 找回密码
  return request({
    url: 'sso/retrieve',
    method: 'post',
    params
  })
}

export function updateUserInfo(data) { // 修改用户信息
  return request({
    url: `sso/update/${data.id}`,
    method: 'post',
    data
  })
}
// 修改注册手机号
export function updatePhone(params) {
  return request({
    url: 'sso/updatePhone',
    method: 'post',
    params
  })
}
// 变更注册手机号
export function replacePhone(data) {
  return request({
    url: 'sso/replacePhone',
    method: 'post',
    data
  })
}
// 修改密码
export function updatePassword(params) {
  return request({
    url: 'sso/updatePassword',
    method: 'post',
    params
  })
}
// 获取会员是否绑定qq
export function getBindingInformation(params) {
  return request({
    url: 'sso/getBindingInformation',
    method: 'get',
    params
  })
}
// 根据手机号码查询用户名
export function getAccountByPhone(params) {
  return request({
    url: '/sso/username',
    method: 'get',
    params
  })
}
// 根据用户名和uuid登录
export function accountLogin(params) {
  return request({
    url: '/sso/login/uuid',
    method: 'post',
    params
  })
}

// 绑定手机号
export function memberBindMobilePhoneNumber(data) {
  return request({
    url: '/sso/memberBindMobilePhoneNumber',
    method: 'post',
    data
  })
}

// 会员绑定的第三方列表
export function memberBindList (params) {
  return request({
    url: 'sso/memberBindList',
    method: 'get',
    params
  })
}
// 会员解除第三方绑定
export function unbindWeChat (params) {
  return request({
    url: 'sso/unbindWeChat',
    method: 'get',
    params
  })
}
